import NormElements from "./normElements";
import NormDefault from "./normDefault";
import NormTricky from "./normTricky";

const levelComponents = {
  'norm-elements': NormElements,
  'norm-default': NormDefault,
  'norm-tricky': NormTricky
};

export default function Normal({
  levelType,
  onComplete,
  numberOfAttempts
}) {
  const Component = levelComponents[levelType] || NormElements;

  return (
    <Component
      onComplete={onComplete}
      numberOfAttempts={numberOfAttempts}
    />
  );
}
